import React, { FC } from 'react';
import styles from './modalContentContainer.module.scss';
import { IModalContentContainer } from './modalContentContainer.interface';

export const ModalContentContainer: FC<IModalContentContainer> = ({
  text,
  modalTitle,
  subtitle,
  children,
  customStyles,
}) => {
  return (
    <div className={`${styles.modal_content} ${customStyles}`}>
      <div className={styles.modal_header}>
        {text && <p className={styles.text}>{text}</p>}
        <h2 className={styles.modal_title}>{modalTitle}</h2>
        {subtitle && <p className={styles.modal_subtitle}>{subtitle}</p>}
      </div>
      <div className={styles.modal_body}>{children}</div>
    </div>
  );
};
